import { defineComponent as s, computed as l, openBlock as r, createElementBlock as o, createElementVNode as t, toDisplayString as d, createCommentVNode as f, normalizeStyle as n, createStaticVNode as v } from "vue";
const p = ["viewBox"], _ = /* @__PURE__ */ t("mask", { id: "9c9a28ca-60c0-42f2-8292-c955271dfd84" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#9c9a28ca-60c0-42f2-8292-c955271dfd84)" }, g = { key: 0 }, x = /* @__PURE__ */ v('<path fill="#0052b4" d="M256 0h256v512H0V256Z"></path><path fill="#eee" d="M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z"></path><path fill="#d80027" d="M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z"></path><rect width="64" height="32" x="336" y="256" fill="#6da544" rx="16" ry="16"></rect><circle cx="368" cy="96" r="32" fill="#ff9811"></circle><circle cx="368" cy="144" r="48" fill="#acabb1"></circle><path fill="#338af3" d="M320 144v77c0 36 48 48 48 48s48-12 48-48v-77z"></path><rect width="32" height="128" x="288" y="128" fill="#333" rx="16" ry="16"></rect><rect width="32" height="128" x="416" y="128" fill="#333" rx="16" ry="16"></rect><path fill="#6da544" d="m320 144 48 112 48-112z"></path><path fill="#ffda44" d="M288 288v32h32v8h96v-8h32v-32h-32v8h-96v-8z"></path>', 11), k = { fill: "none" }, u = ["r"], z = /* @__PURE__ */ s({
  __name: "gs",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(a) {
    const e = a, c = l(() => 512 + 2 * e.strokeWidth), i = l(() => -e.strokeWidth), h = l(() => 256 + e.strokeWidth / 2);
    return (y, w) => (r(), o("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${i.value} ${i.value} ${c.value} ${c.value}`
    }, [
      _,
      t("g", m, [
        e.flagName ? (r(), o("title", g, d(e.flagName), 1)) : f("", !0),
        x
      ]),
      t("g", k, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: h.value,
          fill: "none",
          style: n({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, u)
      ])
    ], 8, p));
  }
});
export {
  z as default
};
//# sourceMappingURL=gs-18f0811c.js.map
